module.exports = __webpack_public_path__ + "img/GEOMETRY.8fd0287f.png";